<div class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center" >

        <!-- CONTENT HEADER -->
        <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0">Debida diligencia</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <!-- CONTENT TOOLBAR -->
            <div class="toolbar px-24 py-8">
                <span>Iniciar debida diligencia</span>
            </div>
            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->
            <div class="content p-50" fxLayout="column" fxFlex>

              <div fxLayout="column">

                    <div fxLayout="column" style="max-width:600px; margin:50px;">

                      <div fxFlex>
                        <mat-form-field  fxFlex>
                          <input placeholder="Nombre" matInput [(ngModel)]="LOCAL_DATA.nombre">
                        </mat-form-field>
                      </div>
                      <div fxFlex>
                        <mat-label >Cliente:</mat-label>
                        <span *ngIf="LOCAL_DATA.cliente!=null" fxFlex class="px-20">{{LOCAL_DATA.cliente?.nombre}} / {{LOCAL_DATA.cliente?.documentoDeIdentidad.numero}}</span>
                        <button  style="margin-left:20px;" mat-button mat-raised-button (click)="openDialog()">Seleccionar cliente</button>
                      </div>
                      <div fxFlex>
                        <mat-form-field  fxFlex>
                          <mat-label>Tabla de debida diligencia</mat-label>
                          <mat-select [(ngModel)]="LOCAL_DATA.tipo" class="roleSelect">
                              <mat-option *ngFor="let tipo of tiposDebidaDiligencia" [value]="tipo">
                                  {{tipo}}
                              </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div fxFlex>
                        <mat-form-field  fxFlex>
                          <mat-label>Marco de referencia</mat-label>
                          <mat-select [(ngModel)]="LOCAL_DATA.formulario" class="roleSelect">
                              <mat-option *ngFor="let marco of marcosDeReferencia" [value]="marco">
                                  {{marco.nombre}}
                              </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div fxFlex>
                        <mat-form-field  fxFlex>
                          <mat-label>Tabla de evaluación</mat-label>
                          <mat-select [(ngModel)]="LOCAL_DATA.formulario" class="roleSelect">
                              <mat-option *ngFor="let tabla of tablasDeEvaluacion" [value]="tabla">
                                  {{tabla.nombre}}
                              </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div fxFlex>
                        <mat-form-field color="accent" appearance="fill">
                        <mat-label>Fecha de Finalización</mat-label>
                        <input matInput [matDatepicker]="picker2"
                        [(ngModel)]="LOCAL_DATA.fechaVencimiento">
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div fxFlex>

                        <button mat-raised-button color="accent" class="submit-button" aria-label="Crear"
                                 (click)="addDebidaDiligencia()" [disabled]="LOCAL_DATA.responsable==null || LOCAL_DATA.tipo==null || LOCAL_DATA.fechaVencimiento==null || LOCAL_DATA.nombre=='' || LOCAL_DATA.formulario==null">
                            Guardar
                        </button>

                        <button mat-button mat-flat-button color="warn"
                                (click)="navegateTo('../mis-analisis-de-brechas','')" class="mx-12 my-12">
                            Cancelar
                        </button>

                      </div>

                    </div>

              </div>



            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>
